import type { LapCheck } from './lapReliability'

export const lapTimeTrusted: LapCheck = {
  id: 'lapTimeTrusted',
  reason: 'timeUnreliable',
  isUnreliable: ({ diagnostics }) => diagnostics?.gpsTimeTrusted === false,
}
